export default __webpack_public_path__ + "static/media/CrowdStrike.c7d2f26d.png";